var isFunction=function(a){return!("function"!=typeof a||!a.constructor||!a.call||!a.apply)};export default isFunction;